import { GridSettingsIncludesMultipleLayoutsBaseValueConverter } from 'General/Resources/ValueConverters/GridSettingsIncludesMultipleLayoutsBase';

export class GridSettingsIncludesMultipleLayoutsValueConverter extends GridSettingsIncludesMultipleLayoutsBaseValueConverter {

}